import clientConfig, { COUNTRY_AVAILABLE_LANGUAGES } from "./client";
export const LANGUAGES = clientConfig.LANGUAGES;
export const LANGUAGES_BY_MARKET = COUNTRY_AVAILABLE_LANGUAGES;
